export const getLocalStorageItem = (key) => {
    if (!key) return null;
    let value = {};
    try {
      value = localStorage.getItem(key);
      if (value && value !== 'undefined' && value !== 'null') {
        value = JSON.parse(value);
      }
      return value;
    } catch (error) {
      console.error('Failed to get localStorage item:', error);
    }
}